import {VariableAbstract} from "./VariableAbstract";
import {ISystem, TRouteId} from "../../index";
import {TServiceName, TServiceParameters} from "../../constants/ApiServices";
import {MAX_RESULTS_PER_PAGE} from "../../constants";
import {getSearchSystemParams} from "../../util/request";
import {getAnyValue} from "../../util/misc";
import {nsTooltip} from "../../util/nsTooltip";

export {template} from "./VariableAbstract"

export class viewModel extends VariableAbstract<ISystem> {
    protected routeId: TRouteId = 'systemaccessdetails';
    protected serviceName: TServiceName = 'searchsystem'

    protected override getParams(): TServiceParameters {
        return getSearchSystemParams({
            resultsprpage: MAX_RESULTS_PER_PAGE,
        })
    }

    protected override getTitle(): string {
        return nsTooltip.getTitle_system(getAnyValue(this.item)) ?? ''
    }

}